import React, { useState, useEffect, useRef, useContext } from "react";
import io from "socket.io-client";
import "./ChatRoom.scss";
import moment from "moment";
import Modal from "react-modal";
import { useParams,Link, useNavigate,useLocation } from 'react-router-dom';
import { AuthContext } from "../../login/AuthContext";
import translations from '../../../utils/language/translations.json';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

  
import 'moment/locale/fr';  // Include other locales as needed
import {shouldShowDateSeparator,getFormattedDateLabel} from '../../../utils/dateHelpers.js'
const socket = io(`${process.env.REACT_APP_API_BASE}`, {
    transports: ["websocket", "polling"],  // ✅ Ensures compatibility with different browsers
    reconnectionAttempts: 5,               // ✅ Retry if disconnected
    timeout: 10000,                         // ✅ Wait 10 seconds before failing
  });
  
  // ✅ Handle WebSocket Connection & Errors
  socket.on("connect", () => {
    console.log("✅ Connected to WebSocket server!");
  });
  
  socket.on("messageReceived", (message) => {
    console.log("📨 New message received:", message);
  });
  
  socket.on("connect_error", (err) => {
    console.error("❌ WebSocket Connection Error:", err);
  });
Modal.setAppElement("#root");

function ChatRoom({ currentUser, selectedConversation,setSelectedConversation,showChatView,setShowChatView,isMobile }) {
    
    const navigate = useNavigate();
    const { userId,userName,ProfilePicture,liveCsrfToken,jwtToken } = useContext(AuthContext);
    const { t: translate, i18n } = useTranslation();
    const currentLang = i18n.language;
    const t = (key) => translations.Message[key][currentLang];
    moment.locale(currentLang);
      const location = useLocation();
    const prefillMessage = location.state?.prefillMessage || "";
    const [formValue, setFormValue] = useState(prefillMessage);
    const [messages, setMessages] = useState([]);
    
    const textareaRef = useRef(null);
    const [selectedImages, setSelectedImages] = useState([]);
    const [previewImages, setPreviewImages] = useState([]);
    const [allImages, setAllImages] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const messagesEndRef = useRef(null);
    useEffect(() => {
        if (!parseInt(currentUser) || !selectedConversation) return;
        

        // ✅ If it's global chat
        if (selectedConversation.isGlobal) {
          fetch(`${process.env.REACT_APP_API_BASE}/messages/global`)
            .then(response => response.json())
            .then(data => {
                console.log('here is data',data)
              setMessages(data);
              const images = data.filter(msg => msg.Image).map(msg => msg.Image);
              setAllImages(images);
            });
      
          // Setup socket for global messages
          const handleGlobalMessage = (message) => {
            console.log('Messagereceived global ^^^^^')
            setMessages(prev => [...prev, message]);
            if (message.Image) {
              setAllImages(prev => [...prev, message.Image]);
            }
          };
      
          socket.on("globalMessageReceived", handleGlobalMessage);
           
          return () => {
            socket.off("globalMessageReceived", handleGlobalMessage);
          };
        }
      
        // ✅ If it's a private chat
        const targetUserId =
          parseInt(currentUser) === selectedConversation.User1Id
            ? selectedConversation.User2Id
            : selectedConversation.User1Id;
      console.log('Target User ID:', targetUserId, 'target currentUser:', currentUser, 'selectedConversation:', selectedConversation);
console.log("currentUser:", currentUser, typeof currentUser);
console.log("User1Id:", selectedConversation?.User1Id, typeof selectedConversation?.User1Id);
console.log("User2Id:", selectedConversation?.User2Id, typeof selectedConversation?.User2Id);
        fetch(`${process.env.REACT_APP_API_BASE}/messages/${currentUser}/${targetUserId}`, {
    method: 'GET',
    credentials: 'include',
   "Authorization": `Bearer ${jwtToken}`,
       "X-CSRF-Token": liveCsrfToken, 
  })
          .then(response => response.json())
          .then(data => {
            setMessages(data);
            console.log('here is data2',data)
            const images = data.filter(msg => msg.Image).map(msg => msg.Image);
            setAllImages(images);
      
            // Reset unread messages count for private chat
            if (data.length > 0) {
              fetch(`${process.env.REACT_APP_API_BASE}/conversations/reset-unread/${currentUser}/${targetUserId}`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: 'include',
                   "Authorization": `Bearer ${jwtToken}`,
       "X-CSRF-Token": liveCsrfToken, 
              });
            }
          });
      
        const handlePrivateMessage = (message) => {
          setMessages(prev => [...prev, message]);
          console.log('here is data3',message)
          if (message.Image) {
            setAllImages(prev => [...prev, message.Image]);
          }
        };
      
        socket.on("messageReceived", handlePrivateMessage);
      
        return () => {
          socket.off("messageReceived", handlePrivateMessage);
        };
      }, [currentUser, selectedConversation]);
      
 

// //    // ✅ Scroll to bottom when messages update
   useEffect(() => {
    if (messagesEndRef.current) {
        messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
}, [messages]);

    const sendMessage = async (e) => {
        e.preventDefault();
    
        const isGlobalChat = selectedConversation?.isGlobal;
        const targetUserId = isGlobalChat
            ? null
            : parseInt(currentUser) === selectedConversation.User1Id
            ? selectedConversation.User2Id
            : selectedConversation.User1Id;
    
        const messageBase = {
            SenderId: parseInt(currentUser),
            ReceiverId: targetUserId,
            Content: formValue,
            Image: null,
            Timestamp: new Date(),
            ShowName: userName, // Make sure you define this via context or props
            ProfilePicture:ProfilePicture,
        };
    
        // ✅ Update DB only for 1-on-1
        if (!isGlobalChat && selectedConversation) {
            const response = await fetch(
                `${process.env.REACT_APP_API_BASE}/conversations/check/${currentUser}/${targetUserId}`
            , {
      method: 'GET',
      credentials: 'include', // Ensure session cookies are sent with the request
    }); 
            const { conversationExists } = await response.json();
    
            if (!conversationExists) {
                await fetch(`${process.env.REACT_APP_API_BASE}/start-conversation`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    credentials: 'include',
                    body: JSON.stringify({
                        SenderId: parseInt(currentUser),
                        RecipientId: targetUserId,
                        LastMessage: formValue || "[Image Sent]",
                    }),
                });
            } else {
                await fetch(`${process.env.REACT_APP_API_BASE}/update-conversation`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    credentials: 'include',
                    body: JSON.stringify({
                        SenderId: parseInt(currentUser),
                        RecipientId: targetUserId,
                        LastMessage: formValue || "[Image Sent]",
                    }),
                });
            }
        }
    
        if (formValue.trim()) {
            const event = isGlobalChat ? "sendGlobalMessage" : "sendMessage";
            socket.emit(event, messageBase);
            console.log('suppose to emit',event)
            // Only optimistic update for private chat
            if (!isGlobalChat) {
                setMessages((prev) => [...prev, messageBase]);
            }
        
            setFormValue("");
        }
    
        // ✅ Send images
        for (const imageFile of selectedImages) {
            const reader = new FileReader();
            reader.readAsDataURL(imageFile);
            reader.onloadend = () => {
                const imageMessage = {
                    ...messageBase,
                    Content: "",
                    Image: reader.result,
                };
                const event = isGlobalChat ? "sendGlobalMessage" : "sendMessage";
                socket.emit(event, imageMessage);
            
                if (!isGlobalChat) {
                    setMessages((prev) => [...prev, imageMessage]);
                }
                setAllImages((prev) => [...prev, reader.result]);
            };
            // reader.onloadend = () => {
            //     const imageMessage = {
            //         ...messageBase,
            //         Content: "",
            //         Image: reader.result,
            //     };
            //     const event = isGlobalChat ? "sendGlobalMessage" : "sendMessage";
            //     socket.emit(event, imageMessage);
            //     setMessages((prev) => [...prev, imageMessage]);
            //     setAllImages((prev) => [...prev, reader.result]);
            // };
        }
    
        setSelectedImages([]);
        setPreviewImages([]);
    };
    
    const handleImageChange = (e) => {
        const files = Array.from(e.target.files);
        const previewUrls = files.map(file => URL.createObjectURL(file)); // ✅ Generate preview URL
    
        setSelectedImages((prev) => [...prev, ...files]);
        setPreviewImages((prev) => [...prev, ...previewUrls]); // ✅ Store preview URLs for display
    };

    const removeImage = (index) => {
        setSelectedImages(prev => prev.filter((_, i) => i !== index));
        setPreviewImages(prev => prev.filter((_, i) => i !== index))
    };

    const IconAddImage = () => {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width={50} height={60} fill="#fff" viewBox="0 0 24 24">
                <path fill="none" d="M0 0h24v24H0z" />
                <path d="M23 4v2h-3v3h-2V6h-3V4h3V1h2v3h3zm-8.5 7a1.5 1.5 0 1 0-.001-3.001A1.5 1.5 0 0 0 14.5 11zm3.5 3.234-.513-.57a2 2 0 0 0-2.976 0l-.655.73L9 9l-3 3.333V6h7V4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7h-2v3.234z" />
            </svg>
        );
    };

    return (
        <div className="chat-room">
            {!isModalOpen && (
               <div className="chat-room__banner">
                {isMobile && (
  <button onClick={(e) => {setShowChatView(false);navigate("/MessageDisplayParent");e.stopPropagation();}} className="back-button">
    ←
  </button>
)}
         {selectedConversation ? (
  selectedConversation.isGlobal ? (
    <>
    <div className="chat-room__header">
      <h2>{t("Global Chat")}</h2>
    </div>
    <div>
    </div>
    </>
  ) : (
    <>
    <div className="chat-room__header">
        
      <Link to={`/ViewUserProfil/${selectedConversation.ShowName}`} className="chat-room__user-link">
        <h2> {selectedConversation.ShowName}</h2>
      </Link>
      {/* Profile image if any */}
    </div>
      <div>
    </div>
    </>
  )

) : (
  <h2>{t('Select a user')}</h2>
)}
           </div>
           
            )}
            <main className="chat-room__main">
                {messages?.length === 0 ? (
                    <div className="chat-room__empty">
                        <p>{t('No messages yet. Start the conversation!')}</p>
                    </div>
                ) : (
                    messages?.map((msg, index) => (
                        <React.Fragment key={msg.MessageId}>
                          {shouldShowDateSeparator(messages, index) && (
                            <div className="chat-date-separator">
                              {getFormattedDateLabel(msg.Timestamp, i18n.language)}
                            </div>
                          )}
                          <ChatMessage
                            message={msg}
                            currentUser={currentUser}
                            allImages={allImages}
                            isModalOpen={isModalOpen}
                            setIsModalOpen={setIsModalOpen}
                            selectedConversation={selectedConversation}
                          />
                        </React.Fragment>
                      ))
                )
                }
                <div ref={messagesEndRef} />
            </main>

            <form className="chat-room__form" onSubmit={sendMessage}>
                <div className="flex-h" style={{paddingBottom:'0px',overflow:'hidden'}}>
                    <textarea
                        value={formValue}
                        onChange={(e) => setFormValue(e.target.value)}
                        placeholder={t("Say something nice")}
                        style={{ width: "90%", borderRadius: "0px", padding: "10px", resize: "none",margin:"0px" }}
                        className="composer"
                         onKeyDown={(e) => {
    if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); sendMessage(e);}
  }}
                    />
                    <label
                        htmlFor="imageUpload"
                        style={{ cursor: "pointer",alignSelf: "center",height: "100%", alignItems: "center", display: "flex" }}
                    >
                        <IconAddImage />
                    </label>
                    <input
                        type="file"
                        id="imageUpload"
                        accept="image/*"
                        multiple
                        onChange={handleImageChange}
                        style={{ display: "none" }}
                    />
                    <button
                        type="submit"
                        className="send"
                        disabled={(!formValue ||!formValue.trim()) && selectedImages.length === 0}
                        style={{height:'100%', alignSelf: "center"}}
                    >
                        {t('Send')}
                    </button>
                </div>
            </form>

            <div className="selected-images">
                {previewImages.map((image, index) => (
                    <div
                        key={index}
                        style={{
                            position: "relative",
                            display: "inline-block",
                            margin: "5px",
                        }}
                    >
                        <img
                            src={image}
                            alt={`Selected ${index}`}
                            style={{ width: "50px", height: "50px", borderRadius: "5px" }}
                        />
                        <button
                            onClick={() => removeImage(index)}
                   
                            className="removeXForPicture"
                        >
                            X
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
}

function ChatMessage({ message, currentUser, allImages, isModalOpen, setIsModalOpen,selectedConversation }) {
    const { t: translate, i18n } = useTranslation();
    const currentLang = i18n.language;
    const t = (key) => translations.Message[key][currentLang];



    const {
        Content: text,
        SenderId: uid,
        Image: image,
        Timestamp: timestamp,
    } = message;
    const messageClass =
        parseInt(uid) === parseInt(currentUser)
            ? "chat-room__sent"
            : "chat-room__received";

    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    
    const openModal = (image) => {
        const index = allImages.findIndex((img) => img === image);
        if (index !== -1) {
            setCurrentImageIndex(index);
            setIsModalOpen(true);
        }
    };

    const closeModal = () => setIsModalOpen(false);

    const nextImage = () => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % allImages.length);
    };

    const prevImage = () => {
        setCurrentImageIndex(
            (prevIndex) => (prevIndex - 1 + allImages.length) % allImages.length
        );
    };

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "ArrowRight") {
                nextImage();
            } else if (e.key === "ArrowLeft") {
                prevImage();
            }
        };

        if (isModalOpen) {
            window.addEventListener("keydown", handleKeyDown);
        }

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [isModalOpen]);

    useEffect(() => {
  if (!isModalOpen) return;
  const onKey = (e) => {
    if (e.key === "Escape") closeModal();
    if (e.key === "ArrowRight") nextImage();
    if (e.key === "ArrowLeft") prevImage();
  };
  window.addEventListener("keydown", onKey);
  return () => window.removeEventListener("keydown", onKey);
}, [isModalOpen, currentImageIndex, allImages]);

    return (
        <div className={`chat-room__message ${messageClass}`}>
              {(text !== '' && text !== null) || image ? (
                <div className="chat-room__timestamp">
                    {moment(timestamp).format("LT")}
                </div>
            ) : null}
{Boolean(selectedConversation?.isGlobal) && message?.ShowName && (
  <Link
    to={
      i18n?.language === "fr"
        ? `/fr/ViewUserProfil/${encodeURIComponent(message.ShowName)}`
        : `/ViewUserProfil/${encodeURIComponent(message.ShowName)}`
    }
    className="chat-room__user"
    onClick={(e) => e.stopPropagation()} // don't bubble from the message
    aria-label={`View ${message.ShowName}'s profile`}
  >
    <img
      src={message.ProfilePicture || "/img/default-avatar.png"}
      alt={`${message.ShowName} profile`}
      className="chat-room__avatar"
      width={28}
      height={28}
      loading="lazy"
      onError={(e) => {
        e.currentTarget.onerror = null;
        e.currentTarget.src = "/img/default-avatar.png";
      }}
    />
    <strong className="chat-room__name" title={message.ShowName}>
      {message.ShowName}
    </strong>
  </Link>
)}

          
            {text !== '' && <p style={{ whiteSpace: "pre-wrap" }}>{text}</p>}
            {/* {image && (
                <>
                    <img
                        src={image}
                        alt="Attached"
                        style={{
                            width: "50px",
                            height: "50px",
                            borderRadius: "10px",
                            marginTop: "10px",
                            cursor: "pointer",
                        }}
                        onClick={() => openModal(image)}
                    />
                    <Modal
                        isOpen={isModalOpen}
                        onRequestClose={closeModal}
                        contentLabel="View Image"
                        style={{
                            content: {
                                marginTop: '50px',
                                top: "50%",
                                left: "50%",
                                right: "auto",
                                bottom: "auto",
                                marginRight: "-50%",
                                transform: "translate(-50%, -50%)",
                                maxWidth: "90vw",
                                maxHeight: "90vh",
                            },
                        }}
                    >
                        <img
                            src={allImages[currentImageIndex]}
                            alt="Full Size"
                            style={{
                                width: "50%",
                                height: "auto",
                                borderRadius: "10px",
                            }}
                        />
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginTop: "10px",
                            }}
                        >
                            <button
                                onClick={prevImage}
                                style={{ padding: "10px", cursor: "pointer" }}
                            >
                                ← {t('Prev')}
                            </button>
                            <button
                                onClick={nextImage}
                                style={{ padding: "10px", cursor: "pointer" }}
                            >
                                {t('Next')} →
                            </button>
                        </div>
                        <button onClick={closeModal} style={{ marginTop: "10px" }}>
                            {t('Close')}
                        </button>
                    </Modal>
                </>
            )} */}
        {image && (
  <>
    <img
      src={image}
      alt={"Attached image"}
      className="thumb"
      onClick={() => openModal(image)}
    />

    <Modal
      isOpen={isModalOpen}
      onRequestClose={closeModal}
      overlayClassName="lightbox__overlay"
      className="lightbox"
      bodyOpenClassName="lightbox--open"  // prevent page scroll
      contentLabel={"View Image"}
      ariaHideApp={false}
      shouldCloseOnOverlayClick
    >
      {/* Header */}
      <div className="lightbox__topbar">
        <div className="lightbox__counter">
          {currentImageIndex + 1} {t("of")} {allImages.length}
        </div>
        <button className="lightbox__close" onClick={closeModal} aria-label={t("Close")}>×</button>
      </div>

      {/* Image area */}
      <div
        className="lightbox__stage"
        onTouchStart={(e) => (window.__swipeX = e.changedTouches[0].clientX)}
        onTouchEnd={(e) => {
          const dx = e.changedTouches[0].clientX - (window.__swipeX || 0);
          if (Math.abs(dx) > 40) (dx < 0 ? nextImage() : prevImage());
        }}
      >
        <img
          src={allImages[currentImageIndex]}
          alt={"Full size"}
          className="lightbox__img"
          draggable={false}
        />

        {/* Edge arrows (desktop) */}
        {allImages.length > 1 && (
          <>
            <button className="lightbox__nav lightbox__nav--left" onClick={prevImage} aria-label={t("Prev")}>‹</button>
            <button className="lightbox__nav lightbox__nav--right" onClick={nextImage} aria-label={t("Next")}>›</button>
          </>
        )}
      </div>

      {/* Footer (mobile friendly taps) */}
      {allImages.length > 1 && (
        <div className="lightbox__footer">
          <button onClick={prevImage} className="btn-ghost">← {t("Prev")}</button>
          <button onClick={nextImage} className="btn-primary">{t("Next")} →</button>
        </div>
      )}
    </Modal>
  </>
)}

        </div>
    );
}

export default ChatRoom;
